export const imageSizeClassMap = {
  sm: "w-6",
  default: "w-8 w-11",
  md: "w-12 w-16",
  lg: "w-16 lg:w-24",
};

export type ImageSize = keyof typeof imageSizeClassMap;
